const ClientData01 = [
  {
    img: "https://via.placeholder.com/225x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/225x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/225x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/225x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/225x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/225x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/225x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/225x110",
    target: "_self",
    link: "#",
  },
];

const ClientData02 = [
  {
    img: "./Images/CertfiedStart1.png",
    UnderImg: "./Images/platinum.png",
    grade: "Platinum",
    link:'/GSN-13578/PRAKHYATAABHINANDCHARITABLETRUST'
  },
  {
    img: "./Images/CertfiedStart2.png",
    UnderImg: "./Images/platinum.png",
    grade: "Platinum",
    link:'/GSN-13946/HOUSINGANDLANDRIGHTSNETWORK'
  },
  {
    img: "./Images/CertfiedStart3.png",
    UnderImg: "./Images/platinum.png",
    grade: "Gold",
    link:'/GSN-11092/RubarooHyd'
  },
  {
    img: "./Images/CertfiedStart4.png",
    UnderImg: "./Images/gold.png",
    grade: "Silver",
    link:'/GSN-11568/Voiceofneedyfoundation'
  },
  {
    img: "./Images/CertfiedStart5.png",
    UnderImg: "./Images/bronze.png",
    grade: "Bronze+",
    link:'/GSN-10034/LFW'
  },
  {
    img: "./Images/CertfiedStart6.png",
    UnderImg: "./Images/bronze.png",
    grade: "Bronze",
    link:'/GSN-4181/AASTHAFOUNDATIONAURANGABAD'
  },
];

const ClientData03 = [
  {
    img: "https://via.placeholder.com/400x160",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/400x160",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/400x160",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/400x160",
    target: "_self",
    link: "#",
  },
];

const ClientData04 = [
  {
    img: "https://via.placeholder.com/120x60",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/120x60",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/120x60",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/120x60",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/120x60",
    target: "_self",
    link: "#",
  },
];

const ClientData05 = [
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
];

const ClientData06 = [
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
];

const ClientData07 = [
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
];

const ClientData08 = [
  {
    img: "https://via.placeholder.com/80x92",
  },
  {
    img: "https://via.placeholder.com/80x92",
  },
  {
    img: "https://via.placeholder.com/80x92",
  },
  {
    img: "https://via.placeholder.com/80x92",
  },
];

export {
  ClientData01,
  ClientData02,
  ClientData03,
  ClientData04,
  ClientData05,
  ClientData06,
  ClientData07,
  ClientData08,
};
